export default function DealsFilterCardsSlug({ selectedTab, setSelectedTab }) {
    const isActive = (tab) =>
        `nav-link ${selectedTab === tab ? "active" : ""}`;

    return (
       

                <ul className="nav nav-tabs deals_inner_page mb-5" id="myTab" role="tablist">

                    <li className="nav-item" role="presentation">
                        <button
                            className={isActive("AllInclusive") + " nav-item d-flex align-items-center gap-2"}
                            onClick={() => setSelectedTab("AllInclusive")}
                            id="all-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#all"
                            type="button"
                            role="tab"
                            aria-selected="true"
                        >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                                    stroke="currentColor" strokeWidth="1.5" />
                                <path
                                    d="M6.00195 4.70994C6.78195 5.42094 8.38995 7.36294 8.57695 9.44694C8.75195 11.3959 10.037 12.9799 12.002 12.9999C12.757 13.0079 13.52 12.4629 13.518 11.7079C13.518 11.4749 13.479 11.2359 13.419 11.0159C13.318 10.6789 13.3476 10.3161 13.502 9.99994C14.112 8.74294 15.312 8.40494 16.262 7.72194C16.683 7.41894 17.068 7.09894 17.237 6.84194C17.706 6.13194 18.174 4.71094 17.94 3.99994M22.002 12.9999C21.672 13.9309 21.44 16.3749 17.72 16.4139C17.72 16.4139 14.427 16.4139 13.439 18.2759C12.648 19.7659 13.109 21.3789 13.439 21.9999"
                                    stroke="currentColor" strokeWidth="1.5" />
                            </svg>
                            All Inclusive
                        </button>
                    </li>

                    <li className="nav-item">
                        <button className={isActive("Flight")}
                            onClick={() => setSelectedTab("Flight")} id="flights-tab" data-bs-toggle="tab" data-bs-target="#flights"
                            type="button">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M17.8 19.2L16 11L19.5 7.5C21 6 21.5 4 21 3C20 2.5 18 3 16.5 4.5L13 8L4.8 6.2C4.3 6.1 3.9 6.3 3.7 6.7L3.4 7.2C3.2 7.7 3.3 8.2 3.7 8.5L9 12L7 15H4L3 16L6 18L8 21L9 20V17L12 15L15.5 20.3C15.8 20.7 16.3 20.8 16.8 20.6L17.3 20.4C17.7 20.1 17.9 19.7 17.8 19.2Z"
                                    stroke="currentColor" strokeWidth="1.5" />
                            </svg>

                            Flights
                        </button>
                    </li>


                    <li className="nav-item">
                        <button
                            className={isActive("Hotel")}
                            onClick={() => setSelectedTab("Hotel")}
                        >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M15 5.76395C14.6897 5.76395 14.3836 5.69173 14.106 5.55302L9.894 3.44702C9.6164 3.3083 9.31033 3.23608 9 3.23608M15 5.76395C15.3103 5.76395 15.6164 5.69173 15.894 5.55302L19.553 3.72302C19.7056 3.64678 19.8751 3.61083 20.0455 3.61858C20.2159 3.62634 20.3814 3.67755 20.5265 3.76735C20.6715 3.85714 20.7911 3.98253 20.874 4.1316C20.9569 4.28067 21.0003 4.44846 21 4.61902V17.383C20.9999 17.5687 20.9481 17.7506 20.8505 17.9085C20.7528 18.0664 20.6131 18.194 20.447 18.277L15.894 20.554C15.6164 20.6927 15.3103 20.7649 15 20.7649M15 5.76395V20.7649M15 20.7649C14.6897 20.7649 14.3836 20.6927 14.106 20.554L9.894 18.448C9.6164 18.3093 9.31033 18.2371 9 18.2371C8.68967 18.2371 8.3836 18.3093 8.106 18.448L4.447 20.278C4.29436 20.3543 4.12473 20.3902 3.95426 20.3824C3.78379 20.3746 3.61816 20.3233 3.47312 20.2334C3.32808 20.1435 3.20846 20.018 3.12565 19.8688C3.04284 19.7196 2.99958 19.5517 3 19.381V6.61802C3.0001 6.43235 3.05189 6.25039 3.14956 6.09249C3.24722 5.93459 3.38692 5.80701 3.553 5.72402L8.106 3.44702C8.3836 3.3083 8.68967 3.23608 9 3.23608M9 3.23608V18.236"
                                    stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
                                    strokeLinejoin="round" />
                            </svg>
                            Hotels
                        </button>
                    </li>

                    <li className="nav-item">
                        <button
                            className={isActive("Vacations")}
                            onClick={() => setSelectedTab("Vacations")}
                        >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M16.24 7.76L14.436 13.171C14.3378 13.4656 14.1724 13.7333 13.9528 13.9528C13.7333 14.1724 13.4656 14.3378 13.171 14.436L7.76 16.24L9.564 10.829C9.66218 10.5344 9.82761 10.2667 10.0472 10.0472C10.2667 9.82761 10.5344 9.66218 10.829 9.564L16.24 7.76Z"
                                    stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
                                <path
                                    d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                                    stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
                            </svg>
                            Vacations
                        </button>
                    </li>

                    <li className="nav-item">
                        <button
                            className={isActive("Tours")}
                            onClick={() => setSelectedTab("Tours")}
                        >

                             <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M16.24 7.76L14.436 13.171C14.3378 13.4656 14.1724 13.7333 13.9528 13.9528C13.7333 14.1724 13.4656 14.3378 13.171 14.436L7.76 16.24L9.564 10.829C9.66218 10.5344 9.82761 10.2667 10.0472 10.0472C10.2667 9.82761 10.5344 9.66218 10.829 9.564L16.24 7.76Z"
                                stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
                            <path
                                d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                                stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
                        </svg>
                            Tours
                        </button>
                    </li>

                    <li className="nav-item">
                        <button
                            className={isActive("Cruises")}
                            onClick={() => setSelectedTab("Cruises")}
                        >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M12 10.189V14M12 10.189C12.2797 10.189 12.5564 10.2474 12.812 10.361L21 14C21.0158 16.1101 20.4557 18.1846 19.38 20M12 10.189C11.7203 10.189 11.4436 10.2474 11.188 10.361L3 14C2.95371 16.8437 3.95372 19.6053 5.81 21.76M12 2V5M19 13V7C19 6.46957 18.7893 5.96086 18.4142 5.58579C18.0391 5.21071 17.5304 5 17 5H7C6.46957 5 5.96086 5.21071 5.58579 5.58579C5.21071 5.96086 5 6.46957 5 7V13M2 21C2.6 21.5 3.2 22 4.5 22C7 22 7 20 9.5 20C10.8 20 11.4 20.5 12 21C12.6 21.5 13.2 22 14.5 22C17 22 17 20 19.5 20C20.8 20 21.4 20.5 22 21"
                                    stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
                                    strokeLinejoin="round" />
                            </svg>
                            Cruises
                        </button>
                    </li>

                    <li className="nav-item">
                        <button
                            className={isActive("Adventures")}
                            onClick={() => setSelectedTab("Adventures")}
                        >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8 3L12 11L17 6L22 21H2L8 3Z" stroke="currentColor" strokeWidth="1.5"
                                    strokeLinejoin="round" />
                            </svg>
                            Adventures
                        </button>
                    </li>

                </ul>

          
    );
}
